import type { LucideIcon } from 'lucide-react'
import { FileQuestion, Home } from 'lucide-react'
import { Link } from '#router'
import { Button } from '@/components/ui/button'
import Footer from './footer'

interface NotFoundProps {
  message?: string
  buttonLabel?: string
  buttonHref?: string
  buttonIcon?: LucideIcon
}

export default function NotFound({
  message = "The page you're looking for doesn't exist.",
  buttonLabel = 'Go Home',
  buttonHref = '/',
  buttonIcon: ButtonIcon = Home,
}: NotFoundProps) {
  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col">
      <div className="container m-auto flex items-center justify-center px-4 py-12">
        <div className="space-y-6 text-center">
          <div className="flex justify-center">
            <div className="bg-muted flex h-20 w-20 items-center justify-center rounded-full">
              <FileQuestion className="text-muted-foreground h-10 w-10" />
            </div>
          </div>
          <div className="space-y-2">
            <h1 className="text-4xl font-bold tracking-tight">
              404 — Not Found
            </h1>
            <p className="text-muted-foreground text-lg">{message}</p>
          </div>
          <Button asChild size="lg" variant="outline">
            <Link href={buttonHref}>
              <ButtonIcon className="mr-2 h-4 w-4" />
              {buttonLabel}
            </Link>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  )
}
